import React, {useContext} from 'react'
import {styled} from '@mui/styles'
import create from 'helpers/command'

import Dialog from './Dialog'

import {TeacherContext} from 'teacher/context'

const StyledDeleteHomework = styled(Dialog)(deleteHomeworkStyles)


export default function DeleteHomework(props) {

    const context = useContext(TeacherContext)

    const {updateState, homeworkContext: {deleteHomework: {open, homework}}} = context
    
    function onClose() {
        return updateState({homeworkContext: {deleteHomework: { open: {$set: false}, homework: {$set: undefined}}}})
    }

    async function onConfirm() {
      const [deletedId] = await create('homework', 'deleteHomework')({id: homework.id})
      props.onDelete && props.onDelete(deletedId)
      await onClose()
      await context.updateState({homeworkContext: {homeworks: {refreshes: {$apply: i => i + 1}}}})
    }

    const shouldConfirm = homework ? homework.turnIns > 0 : false
    const notificationId = shouldConfirm ? 'new-homework-delete' : 'homework-delete'

    return <StyledDeleteHomework {...{open, context, onClose, onConfirm, shouldConfirm, notificationId}} />
}

function deleteHomeworkStyles() {
    return {}
}
